import { render, staticRenderFns } from "./EditPauthCallback.vue?vue&type=template&id=4f9a0a66&"
import script from "./EditPauthCallback.vue?vue&type=script&lang=ts&"
export * from "./EditPauthCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports